import React, { useCallback, useEffect, useState } from 'react'

// Ant design
import { Checkbox, Collapse, Input, message, Tooltip } from 'antd'
// Other
import { CaretRightOutlined, SearchOutlined } from '@ant-design/icons'
import { inject, observer } from 'mobx-react'
import { blue } from '../../../color'
import { ASSIGNEE_TYPE } from '../../../constants'
import utils from '../../../utils'
import { AvatarHasName } from '../../Common/Avatar'
import { EmptyText } from '../../Common/CellText'
import SpinnerInlineComponent from '../../SpinnerInlineComponent'
import { BoxWrapper, PanelItem } from './SelectGroupBoxStyled'

const SelectGroupBox = props => {
  const {
    selectPeopleStore,
    disableGroupList,
    loadingAnimationStore,
    onlySelectOne,
    isVisibleSelectGroupPopup,
    departmentStore,
    isClose
  } = props

  const {
    groupList,
    setGroupList,
    originGroupList,
    assigneePopupType,
    selectGroupData,
    setSelectGroupData,
  } = selectPeopleStore

  const { getDepartmentAllList, departmentAllList } = departmentStore

  useEffect(() => {
    if (!departmentAllList || departmentAllList.length === 0) {
      getDepartmentAllList()
    }
  }, [departmentAllList])

  const handleSelectGroup = useCallback(
    group => {
      if (!assigneePopupType || !group) return

      const isSelectedGroup = selectGroupData[assigneePopupType]?.some(
        el => parseInt(el.id) === parseInt(group.id)
      )

      // Nếu nhóm đã được chọn => Bỏ chọn nhóm đó
      if (isSelectedGroup) {
        setSelectGroupData({
          ...selectGroupData,
          [assigneePopupType]: selectGroupData[assigneePopupType].filter(
            el => parseInt(el.id) !== parseInt(group.id)
          ),
        })
        return
      }

      // Nếu onlySelectOne = true, bỏ chọn tất cả trước khi thêm mới
      const newGroupData = onlySelectOne
        ? [
          {
            assignee_type: ASSIGNEE_TYPE.GROUP,
            full_name: group.name,
            id: group.id,
            permission: assigneePopupType,
          },
        ]
        : [
          ...(selectGroupData[assigneePopupType] || []),
          {
            assignee_type: ASSIGNEE_TYPE.GROUP,
            full_name: group.name,
            id: group.id,
            permission: assigneePopupType,
          },
        ]

      setSelectGroupData({
        ...selectGroupData,
        [assigneePopupType]: newGroupData,
      })
    },
    [assigneePopupType, selectGroupData, onlySelectOne]
  )

  const handleSearchGroup = useCallback(
    event => {
      setValueSearch(event.target.value)
      if (event.target.value.trim() === '') {
        setGroupList(originGroupList)
        return
      }
      const listGroupFilter = originGroupList.filter(group =>
        utils
          .nonAccentVietnamese(group.name)
          .includes(utils.nonAccentVietnamese(event.target.value))
      )
      setGroupList(listGroupFilter)
    },
    [originGroupList]
  )

  const [valueSearch, setValueSearch] = useState('')

  const handleOpenGroup = async group => {
    if (
      !group ||
      groupList.find(el => parseInt(el.id) === parseInt(group.id)).users
        .length > 0
    )
      return
    try {
      loadingAnimationStore.setShowSpinInline(true)
      await selectPeopleStore.getMemberGroup(group.id)
    } catch (err) {
      message.error(err.vi || 'Đã có lỗi xảy ra!')
      console.log(err)
    } finally {
      loadingAnimationStore.setShowSpinInline(false)
    }
  }

  useEffect(() => {
    setValueSearch('')
  }, [isVisibleSelectGroupPopup])

  const [activeKey, setActiveKey] = useState([])
  useEffect(() => {
    if (isClose) {
      setActiveKey([]);
    }
  }, [isClose]);

  return (
    <BoxWrapper>
      <div className={'search-box'}>
        <label style={{ fontWeight: 500, marginRight: 10 }}>
          <SearchOutlined style={{ marginRight: 4, color: blue }} />
          Tìm kiếm:
        </label>
        <Input
          placeholder={'Nhập tên nhóm...'}
          style={{ width: 300 }}
          onChange={event => handleSearchGroup(event)}
          value={valueSearch}
        />
      </div>
      <div className={'collapse-wrapper'}>
        <Collapse
          activeKey={activeKey}
          onChange={setActiveKey}
          collapsible="header"
          expandIcon={({ isActive }) => (
            <CaretRightOutlined rotate={isActive ? 90 : 0} />
          )}
        >
          {groupList.map(group => {
            const checked =
              assigneePopupType &&
              selectGroupData[assigneePopupType]?.some(
                el => parseInt(el.id) === parseInt(group.id)
              )
            const disabled =
              disableGroupList.includes(group.id) ||
              disableGroupList.includes(group.id + '')
            return (
              <PanelItem
                extra={
                  <div
                    className={'extra'}
                    onClick={() => handleOpenGroup(group)}
                  />
                }
                checked={checked}
                collapsible
                key={group.id}
                header={
                  <Tooltip
                    title={disabled ? 'Phòng ban này đã được chọn' : null}>
                    <div
                      style={{ width: '100%' }}
                      onClick={e => {
                        e.stopPropagation()
                        if (disabled) return
                        handleSelectGroup(group)
                      }}
                      className={`group-item ${checked && 'group-item-checked'
                        } ${disabled && 'group-item-disabled'}`}>
                      <Checkbox checked={checked} disabled={disabled} />
                      <span className={'group-name'}>{group.name}</span>
                    </div>
                  </Tooltip>
                }>
                {group.users.length > 0 ? (
                  group.users.map(user => {
                    let department = departmentAllList.find(
                      d => d.code === user.user?.deparment
                    )
                    let deparmentName
                    if (department) {
                      deparmentName = department.name
                    } else {
                      deparmentName = user.user?.deparment
                    }
                    return (
                      <div className={'user-item'} key={user.id}>
                        <AvatarHasName
                          name={user.user.name_lowercase}
                          position={deparmentName}
                          imgId={user.image_id}
                        />
                      </div>
                    )
                  })
                ) : (
                  <div style={{ padding: '10px 0 10px 60px' }}>
                    <EmptyText>Không có người dùng</EmptyText>
                  </div>
                )}
              </PanelItem>
            )
          })}
        </Collapse>
        {/* <SpinnerInlineComponent sizeSpin={'small'} /> */}
      </div>
    </BoxWrapper >
  )
}

export default inject(
  'userStore',
  'loadingAnimationStore',
  'selectPeopleStore',
  'departmentStore'
)(observer(SelectGroupBox))
